import styled from '../../../../../styles/styledComponents/themeComponents';

export const UploadStatusStyle = styled.div<{ status: boolean }>`
  color: ${(props) => (props.status ? '#00e424' : '#ff001f')};
`;
